import React, { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import {
  forceStayLoggedIn,
  getIdleMs,
  SESSION_IDLE_MS,
  shouldShowIdleWarning,
} from '../../services/sessionManager';

const SessionExpiryModal: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const [open, setOpen] = useState(false);
  const [extending, setExtending] = useState(false);

  const checkWarning = useCallback(() => {
    if (!isAuthenticated) {
      setOpen(false);
      return;
    }
    setOpen(shouldShowIdleWarning());
  }, [isAuthenticated]);

  useEffect(() => {
    checkWarning();
    const intervalId = window.setInterval(checkWarning, 10000);
    return () => window.clearInterval(intervalId);
  }, [checkWarning]);

  const handleStayLoggedIn = async () => {
    setExtending(true);
    try {
      const ok = await forceStayLoggedIn();
      if (ok) {
        setOpen(false);
      }
    } finally {
      setExtending(false);
    }
  };

  if (!open) return null;

  const idleMs = getIdleMs();
  const remainingMs = Math.max(0, SESSION_IDLE_MS - idleMs);
  const remainingMinutes = Math.max(1, Math.ceil(remainingMs / 60000));

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-[60] p-3 sm:p-4">
      <div className="relative top-20 mx-auto w-full max-w-md rounded-lg bg-white p-6 shadow-lg">
        <h3 className="text-lg font-semibold text-gray-900">Session expiring soon</h3>
        <p className="mt-2 text-sm text-gray-600">
          You have been inactive. Your session will end in about {remainingMinutes}{' '}
          {remainingMinutes === 1 ? 'minute' : 'minutes'} unless you stay logged in.
        </p>
        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={handleStayLoggedIn}
            disabled={extending}
            className="rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700 disabled:opacity-50"
          >
            {extending ? 'Extending...' : 'Stay logged in'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionExpiryModal;
